import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DrrCcdDeviceApplicationDto } from 'src/app/+drr-ccd-devices/technical-data/technical-data.domain';

@Component({
  selector: 'app-drr-ccd-devices-jurisdiction',
  templateUrl: './drr-ccd-devices-jurisdiction.component.html',
  styleUrls: ['./drr-ccd-devices-jurisdiction.component.scss'],
})
export class DrrCcdDevicesJurisdictionComponent implements OnInit {
  public form: FormGroup;

  @Input() initialData: DrrCcdDeviceApplicationDto;
  @Output() formInitiated: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      consumption_device_type: this.fb.control(null, [Validators.required]),
    });

    if (this.initialData) {
      this.form.patchValue({
        consumption_device_type: this.initialData.is_registration_device ? 'drr' : 'ccd',
      });
    }

    this.formInitiated.emit(this.form);
  }
}
